export let Colors;

(function (Colors) {
  Colors["green"] = "#b6ff00";
  Colors["yellow"] = "#ffdc00";
  Colors["purple"] = "#d400ff";
  Colors["cyan"] = "#00f0ff";
  Colors["neonGreen"] = "#00ff32";
})(Colors || (Colors = {}));

export const toolColor = Colors.green;
export const selectedColor = Colors.neonGreen;